/* 注册全局组件 */
import Vue from 'vue';

import Img from './Img.vue';

Vue.component('g-img', Img);